import React from 'react';

import { UniversityPageLayout } from './UniversityPageLayout';

const UnivserityPageContainer: React.FC = () => {

	return (
		<React.Fragment>
			<UniversityPageLayout/>
		</React.Fragment>
	);
};

export default UnivserityPageContainer;